import {
  Datagrid,
  EditButton,
  FunctionField,
  List,
  ListActions,
  NumberField,
  SelectField,
  SimpleList,
  TextField,
  TextInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import SecuredComponent from "server/security/SecuredComponent";
import { DormitoryRoomConditionStatuses, MOBILE_BREAKPOINT } from "utils/constants";
import { DormitoryRoomConditionStatusChoices } from "utils/choices";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { dormitoryRequests } from "api/dormitoryApi";
import StatusToggleDialog from "../Partials/StatusToggleDialog";
import DatagridActions from "../Partials/DatagridActions";
import DatagridHeader from "../Partials/DatagridHeader";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";
import { isManualRoomCondition } from "../Partials/roomConditions";

const listFilters = [
  <TextInput
    source="description"
    label="Описание"
    alwaysOn
  />,
  <DormitoryAutocompleteInput
    source="status"
    label="Статус"
    choices={DormitoryRoomConditionStatusChoices}
    alwaysOn
    emptyText={"Всички"}
  />,
];

const roomConditionStatusToggle = record => (
  <SecuredComponent permission={permissions.canManageDormitoryRoomConditions}>
    <StatusToggleDialog
      isActive={record?.status === DormitoryRoomConditionStatuses.Active}
      activateUrl={dormitoryRequests.activateRoomCondition(record?.id)}
      deactivateUrl={dormitoryRequests.deactivateRoomCondition(record?.id)}
      confirmMessage="Сигурни ли сте, че искате да смените статуса на състоянието?"
      successMessage="Успешно сменихте статуса на състоянието"
    />
  </SecuredComponent>
);

// Automatic conditions are maintained by the backend from live occupancy, so they are listed and
// readable like any other row but offer neither editing nor deactivation. Manual entries keep the
// behaviour they had. A row whose kind cannot be established offers nothing either - see the helper.
const roomConditionActions = record =>
  isManualRoomCondition(record) ? (
    <>
      <SecuredComponent permission={permissions.canManageDormitoryRoomConditions}>
        <EditButton label="Редактирай" />
      </SecuredComponent>
      {roomConditionStatusToggle(record)}
    </>
  ) : null;

const ListRoomConditions = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Състояния на стаите"
      exporter={false}
      filters={listFilters}
      actions={
        <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageDormitoryRoomConditions)} />
      }
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Описание", value: record?.descriptionBg }]} />
          )}
          secondaryText={() => (
            <div>
              <MobileListRow fields={[{ label: "Стаи", value: <NumberField source="roomsCount" /> }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Настанени студенти",
                    value: <NumberField source="accommodatedStudentsCount" />,
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: <SelectField source="status" choices={DormitoryRoomConditionStatusChoices} />,
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => roomConditionActions(record, true)}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="descriptionBg"
            label={<DatagridHeader align="left">Описание</DatagridHeader>}
            sortable={false}
          />
          <NumberField
            source="roomsCount"
            label={<DatagridHeader align="right">Стаи</DatagridHeader>}
            textAlign="right"
            sortable={false}
          />
          <NumberField
            source="accommodatedStudentsCount"
            label={<DatagridHeader align="right">Настанени студенти</DatagridHeader>}
            textAlign="right"
            sortable={false}
          />
          <SelectField
            source="status"
            label={<DatagridHeader align="left">Статус</DatagridHeader>}
            choices={DormitoryRoomConditionStatusChoices}
            sortable={false}
          />
          <FunctionField
            source="actions"
            label={false}
            sortable={false}
            render={record => <DatagridActions>{roomConditionActions(record)}</DatagridActions>}
          />
        </Datagrid>
      )}
    </List>
  );
};
export default ListRoomConditions;
